module.exports = __webpack_public_path__ + "media/images/icons/vendors/hairstyle_makeup-8f0f39413fd248f225a1cad600acda56.png";